import React, { useState, useEffect,useRef } from "react";
import SelectBoxSearch from "../../common/SelectBoxSearch";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import Notifications from "../../../components/common/Notifications";
import "../../../style/numbertextstyle.css";
import useFormValidation from "../../common/useFormValidation";
import api from "../../../apis/api";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
} from "reactstrap";

const AddEditFormProject = React.memo(
  ({
    selectedProject,
    empList,
    skillList,
    toogleFromProjectAddEditForm,
    handleAddProject,
    handleUpdateProject,
  }) => {
    const [projectName, setProjectName] = useState("");
    const [client, setClient] = useState("");
    const [domain, setDomain] = useState("");
    const [sourceCodePath, setSourceCodePath] = useState("");
    const [technologiesArr, setTechnologiesArr] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [estResourceCost, setEstResourceCost] = useState(0);
    const [projectBudget, setProjectBudget] = useState(0);
    const [managementCost, setManagementCost] = useState(0);
    const [estHrPerManDays, setEstHrPerManDays] = useState(0);
    const [status, setStatus] = useState(0);
    const [uploadFiles, setUploadFiles] = useState("");
    const [projectCompletion, setProjectCompletion] = useState(0);
    const [technology,setTechnology]=useState(0);
    const [leaders, setLeaders] = useState({});
    const [leaderList,setleaderList] = useState([]);
    const [managerList,setmanagerList] = useState([]);
    const [members, setMembers] = useState([]);
    const [projectDescp, setProjectDescp] = useState("");
    const [statusarrayselect, setStatusarray] = useState("");
    const [error, setError] = useState(null);  
    const [selleader,setselleader]=useState(0);
    const [selmanager,setselmanager]=useState(0);
    const [selmember,setselmember]=useState(0);
    const [employeeFormValidation, setEmployeeFormValidation] = useState({});
    const [isActive, setIsActive] = useState(true);
    const callValidation = useRef(false);
      const [usernameCheck, setCheckStatus] = useState("");
      const [formCancelled, setFormCancelled] = useState(false);
    const { formValidation, isFormValid } = useFormValidation(
      employeeFormValidation
    );
    let statusarray=[];
    statusarray.push({value:1,label:"New"});
    statusarray.push({value:2,label:"In Progress"});
    statusarray.push({value:3,label:"Completed"});

                let skillListarray=[];
                skillList.map((el,i) =>{
                  skillListarray.push({value:el.skillId,label:el.skillName});
                });
                //skillList
useEffect(() => {
  if (callValidation.current) {
    if (!formCancelled) {
      handleSubmitForm();
    }
    // Always reset after processing validation, not before it triggers
    callValidation.current = false;
  }
}, [formValidation]);



                const formValidationOnSubmit = () => {
  setFormCancelled(false); // reset cancel flag before validation
  let formValidationList = {
    projectName: {
      required: true,
      isValid: true,
      value: String(projectName),
      errorMessage: "",
    },
    skillId: {
      required: true,
      isValid: true,
      value: selectedProject
        ? (technologiesArr.length === 0 ? '' : technologiesArr)
        : (technology == 0 ? '' : technology),
      errorMessage: "",
    },
    employeeId: {
      required: true,
      isValid: true,
      value: selectedProject
        ? (leaderList.length === 0 ? '' : leaderList)
        : (selleader == 0 ? '' : selleader),
      errorMessage: "",
    },
    memberId: {
      required: true,
      isValid: true,
      value: selectedProject
        ? (members.length === 0 ? '' : members)
        : (selmember == 0 ? '' : selmember),
      errorMessage: "",
    },
    statusId: {
      required: true,
      isValid: true,
      value: statusarrayselect,
      errorMessage: "",
    },
  };
  setEmployeeFormValidation(formValidationList);
  callValidation.current = true;
};


    useEffect(() => {
      if (selectedProject) {
        setProjectName(selectedProject.projectName);
        setClient(selectedProject.clientName);
        setDomain(selectedProject.domain);
        setSourceCodePath(selectedProject.sourceCodePath);
        setTechnologiesArr(selectedProject?.projectTechnologyList);
        setStartDate(selectedProject?.startDate);
        setEndDate(selectedProject?.endDate);
        setProjectCompletion(selectedProject.projectCompletion);
        setEstResourceCost(selectedProject.estimatedCost);
        setProjectBudget(selectedProject.projectBudget);
        setManagementCost(selectedProject.managementCost);
        setEstHrPerManDays(selectedProject.estimatedHours);
        setStatus(selectedProject.projectStatus);
        let array=[];
        if(selectedProject.projectStatus =="1")
        {
          array.push({value:selectedProject.projectStatus ,label:"New"});
          
        }
        else if(selectedProject.projectStatus == "2")
        {
          array.push({value:selectedProject.projectStatus ,label:"In Progress"});
       
        }
        else if(selectedProject.projectStatus == "3")
        {
          array.push({value:selectedProject.projectStatus ,label:"Completed"});
          
        }
        setStatusarray(array);
        // setleaderList({
        //   leaderId: selectedProject.managerID,
        //   leaderName: selectedProject.managerName,
        //   leaderPicture: selectedProject.managerPciture,
        // });
        let leaderData = {
          employeeId: selectedProject.managerID,
          leaderName: selectedProject.managerName,
          leaderPicture: selectedProject.managerPciture,
          roleID:1,
        };
        // setleaderList(leaderData);
        setleaderList([]);
        setleaderList((prevState) => prevState.concat(leaderData));
        setMembers(selectedProject.projectMembersList);
        setmanagerList(selectedProject.projectManagerList);
        setProjectDescp(selectedProject.projectDescription);
        setIsActive(selectedProject.activeStatus ?? true); // default true if null/undefined
        //console.log(selectedProject?.projectTechnologyList)
      } else {
        //console.log("add");
        setProjectName("");
        setClient("");
        setDomain("");
        setSourceCodePath("");
        setTechnologiesArr([]);
        setStartDate(new Date());
        setEndDate(new Date());
        setEstResourceCost(0);
        setProjectBudget(0);
        setManagementCost(0);
        setEstHrPerManDays(0);
        setStatus(0);
        setLeaders({});
        setMembers([]);
        setProjectDescp("");
        setTechnology(0);
        setselleader(0);
        setselmember(0);
        setselmanager(0);
        setleaderList([]);
        setStatusarray("");
        setProjectCompletion(0);
        setIsActive(true); // default true
      }
    }, [selectedProject]);
    const handleChangeStartDate = (date) => {
      setStartDate(date);
    };
    // Function --------------
    // on change the technology select box.
    const handleOnchangeTechnology = React.useCallback((e) => {
      if(e.target.selectedIndex !=0)
      {
        let skillName = e.target[e.target.selectedIndex].getAttribute(
          "data-skillname"
        );
        let skillId = parseInt(e.target.value);
        let skillCategoryId = parseInt(
          e.target[e.target.selectedIndex].getAttribute("data-skillcategoryid")
        );
        let technologyData = {
          skillName: skillName,
          skillId: skillId,
          isSelected: true,
          skillCategoryId: skillCategoryId,
        };
        setTechnology(skillId);
        const response=technologiesArr.some(item => item.skillId === technologyData.skillId);
        if(response != true)
        {
          setTechnologiesArr((prevState) => prevState.concat(technologyData));
        }
        else
        {
          setError({ ...error, message: "Technology already added", status: 400 });
        //  alert("Employee already added to the list");
        }
      }
      
      //console.log(technologyData);
      // apendTechnology(technologyData);
    }, [technologiesArr]);

    // delete the selected leader.
    const delTechnology = React.useCallback(
      (index) => {
        let delTechnologyArr = technologiesArr;
        let tempArr = delTechnologyArr.filter((el) => el.skillId !== index);
        setTechnologiesArr(tempArr);
      },
      [technologiesArr]
    );

    // append leader to array.
    const apendLeader = React.useCallback(
      (leader) => {
        let leaderData = {
          leaderId: leader.value.employeeId,
          leaderName: leader.label,
          leaderPicture: leader.value.profilePicture,
          roleID:1,
        };
        // setleaderList(leaderData);
        setleaderList([]);
        setselleader(parseInt(leader.value.employeeId));
        setleaderList((prevState) => prevState.concat(leaderData));
        // setLeaders((prevState) => prevState.concat(leaderData));
      },
      []
    );
    const apendManager = React.useCallback(
      (manager) => {
        let memberData = {
          memberName: manager.label,
          profilePicture: manager.value.profilePicture,
          projectName: projectName,
          projectID: 0,
          employeeId: manager.value.employeeId,
          roleID: 1,
          employeeName:manager.value.employeeName,
        };
        setselmanager(parseInt(manager.value.employeeId));
        const response=managerList.some(item => item.employeeId === manager.value.employeeId);
        if(response != true)
        {
          setmanagerList((prevState) => prevState.concat(memberData));
        }
        else
        {
         alert("Employee already added to the list");
        }
       
      },
      [setmanagerList,setselmanager, projectName,managerList]
    );
    
    // append member to array.
    const apendMember = React.useCallback(
      (member) => {
        let memberData = {
          memberName: member.label,
          profilePicture: member.value.profilePicture,
          projectName: projectName,
          projectID: 0,
          employeeId: member.value.employeeId,
          roleID: 1,
          employeeName:member.value.employeeName,
        };
        setselmember(parseInt(member.value.employeeId));
        const response=members.some(item => item.employeeId === member.value.employeeId);
        if(response != true)
        {
          setMembers((prevState) => prevState.concat(memberData));
        }
        else
        {
         alert("Employee already added to the list");
        }
       
      },
      [setMembers, projectName,members]
    );
    // delete the selected leader.
    const delLeader = React.useCallback((index) => {
      const filteredLeaders = leaderList
      .slice(0, index)
      .concat(leaderList.slice(index + 1, leaderList.length));
      setleaderList(filteredLeaders);
    }, [leaderList]);
      // delete the selected Manager.
      const delManager = React.useCallback((index) => {
        const filteredManagers = managerList
        .slice(0, index)
        .concat(managerList.slice(index + 1, managerList.length));
        setmanagerList(filteredManagers);
      }, [managerList]);
    // delete the selected member.
    const delMemeber = React.useCallback(
      (index) => {
        const filteredMembers = members
          .slice(0, index)
          .concat(members.slice(index + 1, members.length));
        setMembers(filteredMembers);
      },

      [members]
    );
const handlecleardata =() =>{
  setProjectName("");
  setClient("");
  setDomain("");
  setSourceCodePath("");
  setTechnologiesArr([]);
  setStartDate(new Date());
  setEndDate(new Date());
  setEstResourceCost(0);
  setProjectBudget(0);
  setManagementCost(0);
  setEstHrPerManDays(0);
  setStatus(0);
  setLeaders({});
  setMembers([]);
  setProjectDescp("");
  setTechnology(0);
  setselleader(0);
  setselmember(0);
  setselmanager(0);
  setleaderList([]);
  setStatusarray("");
  setProjectCompletion(0);
}
    const handleSubmitForm = (e) => {
      // e.preventDefault();
      if (isFormValid) {
        if(usernameCheck != "exists")
        {
          setFormCancelled(false);
      if (selectedProject) {
        let formData = {
          projectID: parseInt(selectedProject.projectID),
          projectName: projectName,
          projectType: "string",
          logoImage: "string",
          clientName: client,
          startDate: startDate,
          endDate: endDate,
          technology: "string",
          estimatedHours: parseInt(estHrPerManDays),
          domain: domain,
          managerID:leaderList.length >0 ? (leaderList[0].leaderId) : leaders.leaderId,
          projectDescription: projectDescp,
          uploadFiles: "string",
          sourceCodePath: sourceCodePath,
          estimatedCost: parseInt(estResourceCost),
          projectBudget: parseInt(projectBudget),
          managementCost: parseInt(managementCost),
          projectStatus: parseInt(status),
          projectCompletion: parseInt(projectCompletion),
          createdBy: 0,
          createdOn: "2020-07-10T11:39:40.991Z",
          updatedBy: 0,
          updatedOn: "2020-07-10T11:39:40.991Z",
          activeStatus: isActive,
          skillName: "string",
          skillList: technologiesArr,
          projectMembersList: members,
          projectLeaderList :leaderList,
          projectManagerList:managerList,
        };
        //console.log("in update");
        handleUpdateProject(formData);
        // setError({ ...error, message: "Project Updated", status: 200 });
        // window.location.reload();
      } else {
        let formData = {
          projectName: projectName,
          projectType: "string",
          logoImage: "string",
          clientName: client,
          startDate: startDate,
          endDate: endDate,
          technology: "string",
          estimatedHours: parseInt(estHrPerManDays),
          domain: domain,
          managerID:leaderList.length >0 ? (leaderList[0].leaderId) : 0,
          projectDescription: projectDescp,
          uploadFiles: "string",
          sourceCodePath: sourceCodePath,
          estimatedCost: parseInt(estResourceCost),
          projectBudget: parseInt(projectBudget),
          managementCost: parseInt(managementCost),
          projectStatus: parseInt(status),
          projectCompletion: parseInt(projectCompletion),
          skillList: technologiesArr,
          createdBy: 0,
          createdOn: "2020-07-10T11:39:40.991Z",
          updatedBy: 0,
          updatedOn: "2020-07-10T11:39:40.991Z",
          activeStatus: isActive,
          skillName: "string",
          
        
          skillList: technologiesArr,
          projectMembersList: members,
          projectLeaderList :leaderList,
          projectManagerList:managerList,
        };
        
        // const formDatafile = new FormData();
        // formDatafile.append("projectName",projectName);
        // formDatafile.append("projectType","string");
        // formDatafile.append("logoImage","string");
        // formDatafile.append("clientName",client);
        // formDatafile.append("startDate",startDate);
        // formDatafile.append("endDate",endDate);
        // formDatafile.append("technology","string");
        // formDatafile.append("estimatedHours",parseInt(estHrPerManDays));
        // formDatafile.append("domain",domain);
        // formDatafile.append("managerID",leaderList.length >0 ? (leaderList[0].leaderId) : 0);
        // formDatafile.append("projectDescription",projectDescp);
        // formDatafile.append("uploadFiles","string");
        // formDatafile.append("sourceCodePath",sourceCodePath);

        // formDatafile.append("estimatedCost",parseInt(estResourceCost));
        // formDatafile.append("projectBudget",parseInt(projectBudget));
        // formDatafile.append("managementCost",parseInt(managementCost));

        // formDatafile.append("projectStatus", parseInt(status));
        // formDatafile.append("projectCompletion",parseInt(projectCompletion));
        // formDatafile.append("skillList",technologiesArr);
        // formDatafile.append("createdBy",0);
        // formDatafile.append("createdOn","2020-07-10T11:39:40.991Z");
        // formDatafile.append("updatedBy",0);
        // formDatafile.append("updatedOn","2020-07-10T11:39:40.991Z");
        // formDatafile.append("skillName", "string");
        // formDatafile.append("skillList",technologiesArr);
        // formDatafile.append("projectMembersList",members);
        // formDatafile.append("formfile",uploadFiles);
        // formDatafile.append("projectLeaderList",leaderList);
        // formDatafile.append("activeStatus",true);

        handleAddProject(formData);
        // setError({ ...error, message: "Project Added", status: 200 });
      }
      // window.location.reload();
      handlecleardata();
      toogleFromProjectAddEditForm();
    }
    }
    };
const handlestatussele=(e,val) =>{
  setStatus(val);
  setStatusarray(e);
}

const toogleFromProjectAddEditFormCancel =(e) =>{
  e.preventDefault();
   setFormCancelled(true);
  setTechnologiesArr([]);
  setMembers([]);
  setleaderList([]);
  setTechnology("");
  
  setselleader(0);
  setselmanager(0);
  setselmember(0);
  setEmployeeFormValidation({});
  setStatusarray("");
  setProjectCompletion(0);
  toogleFromProjectAddEditForm();
}
const checkProjectName =async(username) => {
  setCheckStatus("");
    setProjectName(username);

    let checkusernameStatus = await api.dbEmployeeTypes().ProjectNameCheck(username);
    if (checkusernameStatus.status === 200) { 

      if(checkusernameStatus.data === 0){
        // setUserName(username);
        setCheckStatus("");
      }         
      else{
        setCheckStatus("exists");
        // setUserName(username);
      }    
    } else {
      setError({ ...error, message: "Bad Connection" });
    }
  };
    return (
      <Form className="project-form">
        
        <Row form>
               
          <Col md={6}>
            <FormGroup className="padding-r-20">
              <Label for="exampleEmail">Project Name <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
              <Input
                type="text"
                onChange={(e) =>checkProjectName(e.target.value)}
                name="projectName"
                value={projectName}
              />
               {Object.keys(usernameCheck).length !== 0 && usernameCheck=="exists" &&(
                <span className=" " style={{ color: "red" }}>
                  {"Projectname already exists!"}
                </span>
              )}
              {Object.keys(formValidation).length !== 0 &&
              !formValidation.projectName.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.projectName.errorMessage}
                </span>
              )}
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup className="padding-l-20">
              <Label>Client </Label>
              <Input
                type="text"
                onChange={(e) => setClient(e.target.value)}
                value={client}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6}>
            <FormGroup className="padding-r-20">
              <Label>Domain</Label>
              <Input
                type="text"
                onChange={(e) => setDomain(e.target.value)}
                value={domain}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup className="padding-l-20">
              <Label>Source Code Path</Label>
              <Input
                type="text"
                onChange={(e) => setSourceCodePath(e.target.value)}
                value={sourceCodePath}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={3} className="float-center">
            <FormGroup>
              <Label>Start Date</Label>
              <Input
                type="date"
                onChange={(e) => setStartDate(e.target.value)}
                value={moment(startDate).format('YYYY-MM-DD') }
              />
              {/* <DatePicker
                selected={startDate}
                onChange={handleChangeStartDate}
              /> */}
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup className="padding-r-20">
              <Label>End Date</Label>
              <Input type="date" onChange={(e) => setEndDate(e.target.value)} 
              value={moment(endDate).format('YYYY-MM-DD')}/>
            </FormGroup>
          </Col>
        </Row>

        <Row form>
          <Col md={3}>
            <FormGroup>
              <Label>Estimated Resource Cost</Label>
             
              <Input
                type="text"
                onChange={(e) => setEstResourceCost(e.target.value)}
                value={estResourceCost}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup className="padding-r-20">
              <Label>Project Budget </Label>
              <Input
                type="number"
                onChange={(e) => setProjectBudget(e.target.value)}
                value={projectBudget}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup className="padding-l-20">
              <Label>Management Cost </Label>
              <Input
                type="number"
                onChange={(e) => setManagementCost(e.target.value)}
                value={managementCost}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Estimate Hour/Man-days</Label>
              <Input
                type="number"
                onChange={(e) => setEstHrPerManDays(e.target.value)}
                value={estHrPerManDays}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row form>
          <Col md={5} xs={10}>
            <FormGroup>
              <Label>Technology <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
              <Input
                type="select"
                // onChange={(e) => setTechnology(e.target.value)}
                onChange={(e) => handleOnchangeTechnology(e)}

                value={technology}
               
              >
                <option value="0"> select...</option>
                {skillList.map((el) => (
                  <option
                    key={el.skillId}
                    value={el.skillId}
                    data-skillcategoryid={el.skillCategoryId}
                    data-skillname={el.skillName}
                  >
                    {el.skillName}
                  </option>
                ))}
              </Input>
              {(Object.keys(formValidation).length !== 0 &&
              !formValidation.skillId.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.skillId.errorMessage}
                </span>
              ))}
            </FormGroup>
          </Col>
          <Col
            md={1}
            xs={2}
            className="mt-4  "
            style={{ paddingRight: "20px" }}
          ></Col>
          <Col md={6}>
            <FormGroup className="padding-l-20 ">
              <Label className="d-block">Technologies</Label>
              {/* <ul className="bg-dark "> */}
              {technologiesArr?.map((technology, i) => (
                // <li key={i} className="d-inline ml-2 ">
                <Button
                  key={technology.skillId}
                  type="button"
                  size="sm"
                  color="warning"
                  className="mt-2 ml-2 "
                >
                  <small> {technology.skillName}</small>
                  <i
                    className=" ml-2 fas fa-times"
                    onClick={() => delTechnology(technology.skillId)}
                  ></i>
                </Button>
                // </li>
              ))}
              {/* </ul> */}
            </FormGroup>{" "}
          </Col>
        </Row>
        <Row form>
          <Col md={6}>
            <FormGroup className="padding-r-20">
              <Label>Project Leader <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
              <SelectBoxSearch
                options={empList}
                selectedUser={selleader}
                onChange={apendLeader}
              ></SelectBoxSearch>
               {(Object.keys(formValidation).length !== 0 &&
              !formValidation.employeeId.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.employeeId.errorMessage}
                </span>
              )) }
            </FormGroup>
          </Col>
        
          <Col md={6}>
            <FormGroup className="padding-l-20">
              <Label className="d-block">Project Leader</Label>
              {/* {leaderList !=null ? (leaderList.map((leaderList, i) => (
                <h4 key={i} className="form-avatar">
                  <span className="avatar" title={leaderList.leaderName}>
                    <img
                      alt=""
                      src={leaderList.leaderPicture == null ||  leaderList.leaderPicture =='undefined'? (require(`../../../img/employee/user.png`)) : (require(`../../../img/employee/` + leaderList.leaderPicture))}
                     
                    />
                    <div className="overlay">
                      <div className="text">
                        <i
                          className="fas fa-times user-del-icon"
                          onClick={() => delLeader(i)}
                        ></i>
                      </div>
                    </div>
                  </span>
                </h4>
              ))):null} */}
              {(leaderList.length > 0) ? (
                
                <h4 key={leaderList[0].leaderId} className="form-avatar">
                  <span className="avatar" title={leaderList[0].leaderName}>
                    <img
                      alt=""
                      src={leaderList[0].leaderPicture == null || leaderList[0].leaderPicture == "null" || leaderList[0].leaderPicture =='undefined'? (require(`../../../img/employee/user.png`)) : (require(`../../../img/employee/` + leaderList[0].leaderPicture))}
                     
                    />
                    <div className="overlay">
                      <div className="text">
                        <i
                          className="fas fa-times user-del-icon"
                          onClick={() => delLeader(0)}
                        ></i>
                      </div>
                    </div>
                  </span>
                </h4>
             ):null}
              {/* {leaders.map((leader, i) => ( */}
              {/* {leaders.leaderPicture ? (
                <h4 className="form-avatar">
                  <span className="avatar" title={leaders.leaderName}>
                    <img
                      alt=""
                      src={require(`../../../img/employee/${leaders?.leaderPicture}`)}
                    />
                    <div className="overlay">
                      <div className="text">
                        <i
                          className="fas fa-times user-del-icon"
                          onClick={() => delLeader(leaders.leaderId)}
                        ></i>
                      </div>
                    </div>
                  </span>
                </h4>
              ) : null} */}

              {/* ))} */}
            </FormGroup>
          </Col>
        </Row>
        <Row Form>
        <Col md={6}>
            <FormGroup className="padding-r-20">
              <Label>Project Manager <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
              <SelectBoxSearch
                options={empList}
                selectedUser={selmanager}
                onChange={apendManager}
              ></SelectBoxSearch>
               {(Object.keys(formValidation).length !== 0 &&
              !formValidation.employeeId.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.employeeId.errorMessage}
                </span>
              )) }
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup className="padding-l-20">
            <Label className="d-block">Project Manager</Label>
              {managerList?.map((member, i) => (
                <h4 key={i} className="form-avatar">
                  <span className="avatar" title={member.employeeName}>
                    <img
                      alt=""
                      src={member.profilePicture == null || member.profilePicture == "null" || member.profilePicture=='undefined'? (require(`../../../img/employee/user.png`)) : (`https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/${member.profilePicture}`)}
                    />
                    <div className="overlay">
                      <div className="text">
                        <i
                          className="fas fa-times user-del-icon"
                          onClick={() => delManager(i)}
                        ></i>
                      </div>
                    </div>
                  </span>
                </h4>
              ))}
             </FormGroup>
             </Col>
        </Row>
        <Row form>
          <Col md={6}>
            <FormGroup className="padding-r-20">
              <Label>Team Members <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
              <SelectBoxSearch
                options={empList}
                selectedUser={selmember}
                onChange={apendMember}
              ></SelectBoxSearch>
              {(Object.keys(formValidation).length !== 0 &&
              !formValidation.memberId.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.memberId.errorMessage}
                </span>
              ))}
              
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup className="padding-l-20">
              <Label className="d-block"> Team Members</Label>
              {members?.map((member, i) => (
                <h4 key={i} className="form-avatar">
                  <span className="avatar" title={member.employeeName}>
                    <img
                      alt=""
                      src={member.profilePicture == null || member.profilePicture == "null" || member.profilePicture=='undefined'? (require(`../../../img/employee/user.png`)) : (`https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/${member.profilePicture}`)}
                    />
                    <div className="overlay">
                      <div className="text">
                        <i
                          className="fas fa-times user-del-icon"
                          onClick={() => delMemeber(i)}
                        ></i>
                      </div>
                    </div>
                  </span>
                </h4>
              ))}
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={4}>
            <FormGroup>
              <Label>Status <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
             
              <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={statusarray[0]}
        value={statusarrayselect}
        onChange={(e) => {
          handlestatussele(e,e.value);
        }} 
        isSearchable={true}
        name="color"
        options={statusarray}
      />
       {Object.keys(formValidation).length !== 0 &&
              !formValidation.statusId.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.statusId.errorMessage}
                </span>
              )}
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup className="padding-r-20">
              <Label>Completed</Label>
              <Input
                type="number"
                onChange={(e) => setProjectCompletion(e.target.value)}
                value={projectCompletion}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup className="padding-l-20">
              <Label></Label>
              <Input
                type="file"
                name="file"
                onChange={(e) => setUploadFiles(e.target.files[0])}
              />
              <FormText color="muted">
                Upload usefull links, and docs about the Project.
              </FormText>
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={12}>
            <FormGroup>
              <Label>Project Description</Label>
              <Input
                type="textarea"
                onChange={(e) => setProjectDescp(e.target.value)}
                value={projectDescp}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
  <Col md={3}>
    <FormGroup check>
      <Label check>
        <Input
          type="checkbox"
          checked={isActive}
          onChange={(e) => setIsActive(e.target.checked)}
        />{" "}
        Is Active
      </Label>
    </FormGroup>
  </Col>
</Row>

        <Row>
          <Col className="text-center">
            <Button
              // type="submit"
              color=""
              className="btn-admin-settings"
              onClick={formValidationOnSubmit}
            >
              {selectedProject ? "Update" : "Add"}
            </Button>
            &nbsp;
            <Button
              type="button"
              color=""
              className="btn-cancel"
              onClick={toogleFromProjectAddEditFormCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
        <Notifications notifications={error}></Notifications>
      </Form>
    );
  }
);

export default AddEditFormProject;
